import { gql } from '@apollo/client';

export * from './appRequestDecline.mutation.generated';

export const APP_REQUEST_DECLINE = gql`
  mutation appRequestDecline($appRequestId: ID!, $reason: String) {
    appRequestDecline(input: { appRequestId: $appRequestId, reason: $reason }) {
      errors
      success
      appRequest {
        id
      }
    }
  }
`;
